import React from 'react';
import { Icon } from '../ui/Icon.jsx';
import { LangToggle } from '../ui/LangToggle.jsx';
import { LOGO_URL } from '../../lib/constants.js';

/**
 * AdminSidebar — desktop admin nav rail (BRAND.md §8.3 dark surface).
 * Forest background, cream text, tan-accented active state, Lucide icons
 * (no emoji). Mirrors the Claude Design "Sedra Home Design System" Sidebar
 * component, wired to this app's real nav items / role badge / logout.
 */
export function AdminSidebar({ navItems, activeTab, onNav, name, badge, lang, setLang, onLogout, logoutLabel, newOrderCount = 0 }) {
  const ar = lang === 'ar';
  return (
    <div style={{ width: 220, background: 'var(--sedra-nav)', color: 'var(--sedra-ink)', display: 'flex', flexDirection: 'column', flexShrink: 0, position: 'sticky', top: 0, alignSelf: 'flex-start', height: '100vh', overflowY: 'auto', borderInlineEnd: '1px solid var(--sedra-line)' }}>
      <div style={{ padding: '20px 20px 16px', borderBottom: '1px solid var(--sedra-line)', textAlign: 'center' }}>
        <img src={LOGO_URL} alt="Sedra Home" style={{ width: 110, height: 'auto', borderRadius: 8 }} />
        <div style={{ fontSize: 11, color: 'var(--sedra-ink-muted)', marginTop: 8, letterSpacing: ar ? 'normal' : 1, textTransform: ar ? 'none' : 'uppercase' }}>
          {ar ? 'لوحة التحكم' : 'ADMIN PANEL'}
        </div>
        <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5 }}>
          <div style={{ fontSize: 13, color: 'var(--sedra-ink)', fontWeight: 600 }}>{name}</div>
          <span style={{ fontSize: 10, padding: '2px 10px', borderRadius: 10, background: badge.bg, color: badge.color, fontWeight: 700 }}>{badge.label}</span>
        </div>
      </div>
      <nav style={{ flex: 1, padding: '12px 0' }}>
        {navItems.map(item => {
          const on = activeTab === item.key;
          return (
            <button key={item.key} onClick={() => onNav(item.key)} style={{
              width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '11px 20px',
              marginBottom: 2, border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: on ? 700 : 500,
              textAlign: ar ? 'right' : 'left', position: 'relative', fontFamily: 'var(--font-body)',
              background: on ? 'var(--sedra-card)' : 'none',
              color: on ? 'var(--sedra-pistachio-deep)' : 'var(--sedra-ink)',
              borderInlineStart: on ? '3px solid var(--sedra-pistachio-deep)' : '3px solid transparent',
              transition: 'background var(--motion-micro)',
            }}>
              <Icon name={item.icon} size={18} />
              {item.label}
              {item.key === 'orders' && newOrderCount > 0 && (
                <span style={{ marginInlineStart: 'auto', background: 'var(--status-danger)', color: '#fff', borderRadius: 10, padding: '1px 7px', fontSize: 11, fontWeight: 700 }}>{newOrderCount}</span>
              )}
            </button>
          );
        })}
      </nav>
      <div style={{ padding: '16px 20px', borderTop: '1px solid var(--sedra-line)' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
          <LangToggle lang={lang} setLang={setLang} variant="light" />
        </div>
        <button onClick={onLogout}
          style={{ width: '100%', padding: '8px', borderRadius: 7, background: 'var(--sedra-olive)', color: 'var(--sedra-cream)', border: 'none', cursor: 'pointer', fontSize: 13, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
          <Icon name="LogOut" size={14} /> {logoutLabel}
        </button>
      </div>
    </div>
  );
}
